import anime from 'animejs';
import NukaCarousel from 'nuka-carousel';
import { useEffect } from 'react';
import { Button, Container } from 'react-bootstrap';
import styled from 'styled-components';

import CatedralImg from 'assets/carousel/catedral.jpg';
import MistiImg from 'assets/carousel/misti.jpg';
import UrosImg from 'assets/carousel/uros.jpg';
import YanahuaraImg from 'assets/carousel/yanahuara.jpg';

const HeroContainer = styled.div`
    position: relative;
`;

const TextContainer = styled.section`
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.3);

    h1,
    p {
        color: white;
    }

    p {
        font-size: 18px;
        font-weight: 300;
    }
`;

const CarouselImg = styled.img`
    width: 100%;
    height: 100%;

    @media (max-width: ${(props): string => props.theme.md}px) {
        width: auto !important;

        position: absolute;
        left: 50%;
        transform: translate(-50%);
    }
`;

const Carousel = styled(NukaCarousel)`
    .slider-control-bottomcenter {
        z-index: 40000;
    }

    .paging-item button {
        fill: var(--primary-blue) !important;

        :focus {
            outline: 0;
        }
    }
`;

function HeroSection(): JSX.Element {
    useEffect(() => {
        anime({
            targets: '.home-text',
            translateY: [100, 0],
            opacity: [0, 1],
            duration: 800,
            delay: 500,
            easing: 'easeOutSine',
        });
    }, []);

    return (
        <HeroContainer id="home">
            <Carousel
                autoplay
                wrapAround
                transitionMode="fade"
                renderCenterLeftControls={null}
                renderCenterRightControls={null}
                initialSlideHeight={1000}
            >
                <CarouselImg src={CatedralImg} alt="Catedral de arequipa" />
                <CarouselImg src={MistiImg} alt="Volcan misti" />
                <CarouselImg src={YanahuaraImg} alt="Mirador de yanahuara" />
                <CarouselImg src={UrosImg} alt="Isla Uros" />
            </Carousel>

            <TextContainer>
                <Container className="text-center home-text">
                    <h1>Grupo Noral</h1>
                    <p>Somos una distribuidora que difundimos cultura</p>
                    <Button href="#visit">Ubícanos aquí</Button>
                </Container>
            </TextContainer>
        </HeroContainer>
    );
}

export default HeroSection;
